import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { type Site } from '@common/types/site.type';
import { type SitePageEntity } from '@common/types/site-page.type';
import { type DenormalizedBlockEntity } from '@web/types';
import { type Id, type Uuid } from '@common/types';

import ModalsActions from './modals.actions';

@Injectable()
export class ModalsFacade {
    private readonly store = inject(Store);

    public showSaveModalHandler(
        exit: boolean,
        publish: boolean,
        navigateTo?: { pageId?: string; siteId?: string; isNew?: boolean }
    ): void {
        this.store.dispatch(ModalsActions.showSaveModalHandler({ exit, publish, navigateTo }));
    }

    public showSavePageModal(
        exit: boolean,
        publish: boolean,
        navigateTo?: { pageId?: string; siteId?: string; isNew?: boolean }
    ): void {
        this.store.dispatch(ModalsActions.showSavePageModal({ exit, publish, navigateTo }));
    }

    public showSaveSiteModal(
        exit: boolean,
        publish: boolean,
        navigateTo?: { pageId?: string; siteId?: string; isNew?: boolean }
    ): void {
        this.store.dispatch(ModalsActions.showSaveSiteModal({ exit, publish, navigateTo }));
    }

    public showSaveConfirmModal(
        exit: boolean,
        publish: boolean,
        navigateTo?: { pageId?: string; siteId?: string; isNew?: boolean }
    ): void {
        this.store.dispatch(ModalsActions.showSaveConfirmModal({ exit, publish, navigateTo }));
    }

    public showCopyPageModal(siteId: number, page: SitePageEntity): void {
        this.store.dispatch(ModalsActions.showCopyPageModal({ siteId, page }));
    }

    public showCopyBlockToPageModal(
        block: DenormalizedBlockEntity,
        currentSiteId: Site['id'],
        currentPageId: Id | Uuid
    ): void {
        this.store.dispatch(ModalsActions.showCopyBlockToPageModal({ block, currentSiteId, currentPageId }));
    }

    public showConfirmDeleteUserLibraryBlockModal(blockId: Uuid): void {
        this.store.dispatch(ModalsActions.showConfirmDeleteUserLibraryBlockModal({ blockId }));
    }
}
